<template>
  <div class="main-screen">
    <!-- Left Navbar -->
    <div  :class="['navbar-section', { hidden: !isNavbarVisible }]">
      <Navbar ref="navbar"
        @toggle-navbar="adjustMainContent"
      />
    </div>

    <!-- Center Main Content -->
    <div :class="['main-content', { 'full-width': !isNavbarVisible }]" style="margin-left:20px">
      <h2>Interface Designs</h2>
         <!-- Personal Info Section -->
          <div class="personal-info-card">
            <!-- Header -->
            <div class="card-header">
              <h3 class="title">Choose Your Theme</h3>
              
            </div>
                      
            <!-- Content -->
            <div class="info-content" style="align-content:center !important;">
              
              <div class="info-row">
                <div class="info-column">


                  <!-- <InterfaceDesigns/> -->

                    <div class="swiper-container"  ref="swiperContainer">
                        <div class="swiper-wrapper">
                            <div v-for="(value, key) in designExclusiveDic" :key="key" class="swiper-slide">
                            <img class="card-img-left" style="width: 200px; height: auto;" :src="value.video" loading="lazy" @load="onImageLoad" />
                                <button class="btn btn-primary btn-select" :disabled="designOption === key" @click="updateDesignTemplate2(key)" style="margin-top:40px;">Select</button>
                            </div>
                            <div  v-for="(value, key) in designTemplateDic" :key="key" class="swiper-slide">
                                <img class="card-img-left" style="width: 200px; height: auto;" :src="value.video" loading="lazy" @load="onImageLoad" />
                                <button class="btn btn-primary btn-select" :disabled="designOption === key" @click="updateDesignTemplate2(key)" style="margin-top:40px;">Select</button>
                            </div>
                        </div>
                        <br><br>
                        <br><br>
                        <div class="swiper-pagination" ></div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>
                </div>
              </div>
            </div>
          </div>


    </div>
    <!-- Right Preview -->
    <div class="preview-section" v-if="!isMobile" >
      <div class="preview-card">
        <h3 class="preview-title">Preview</h3>
        <div class="preview-content">
          <Preview
          ref="previewComponent"
          :imageId ="this.designOption"
          ></Preview>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Navbar from "../components/navbar.vue";
import Preview from "../components/preview.vue";
// import InterfaceDesigns from "../components/interfaceDesigns.vue"
// import PhonePreview from "./PhonePreview.vue";
// import "cropperjs/dist/cropper.css";
import { doc, onSnapshot,collection, query, orderBy, getDocs,getDoc,where  } from "firebase/firestore";
import { db } from "../firebaseDB";
import router from "@/router";
import {  ref } from "firebase/storage";
import {
  getAuth,
  onAuthStateChanged
} from "firebase/auth";
import Swiper, { Navigation, Pagination,EffectCoverflow } from 'swiper';
import 'swiper/swiper-bundle.css';
export default {
  components: {
    Navbar,
    Preview,
    // InterfaceDesigns
  },
  data() {
    return {
      isNavbarVisible :true,
      cropping: false, // Toggles cropping state
      cropper: null, // Cropper.js instance
      imageSrc: null, // Source of the uploaded image
      defaultPlaceholder: "https://via.placeholder.com/150", // Placeholder image
      
      name: "",
      email: "",
      companyName: "",
      contactNumber: "",
      role: "",
      fb: "",
      twitter: "",
      insta: "",
      linkedin: "",
      website: "",
      profileImg: "",
      address: "",
      companyID: "",
      accID: "",
      response: "",
      id_token: "",
      apiURL: "https://backend-tapfactor-updateuser-migrated-1008798662954.us-central1.run.app",
      officeNumber:"",
      faxNumber:"",
      description:"",
      youtube:"",
      tiktok:"",
      whatsapp:"",
      tele:"",
      snapchat:"",
      docData: "",
      currentPage: "EditInfo",
      updateStatus: "none",
      designOption:"",
      designTemplateDic:{}, 
      designExclusiveDic:{},
      fileSizeLimitInMB:1,
      fileSizeError:"",
      selectedFile:null,
      swiper: null,
      currUserId: "",
      imagePreview:{
          imageGallery1Preview: null,
          imageGallery2Preview: null,
          imageGallery3Preview: null,
          imageGallery4Preview: null,
          imageGallery5Preview: null,
          imageGallery6Preview: null,
          imageGallery7Preview: null,
          imageGallery8Preview: null,
      },
      staticImagePreview:{
          imageGallery1Preview: null,
          imageGallery2Preview: null,
          imageGallery3Preview: null,
          imageGallery4Preview: null,
          imageGallery5Preview: null,
          imageGallery6Preview: null,
          imageGallery7Preview: null,
          imageGallery8Preview: null,
      },
      pdfFile:"",
      pdfName:"",
      pdfChecker: false,
      clonedObject:{}, 
      currPDFFile:"",
      fbReview:"",
      googleReview:"",
      additionalInfo:"",
      profileEdit:true,
      profileLoading:false,
      contactEdit:true,
      contactLoading:false,
      socialEdit:true,
      socialLoading:false,
      addresseEdit:true,
      addressLoading:false,
      descriptionEdit:true,
      descriptionLoading:false,
      accreditationEdit:true,
      accreditationLoading:false,
      resumeEdit:true,
      resumeLoading:false,
      galleryEdit:true,
      galleryLoading:false,
      isMobile: false, // Detect mobile view
      excludeList: ["LHN1JEN5","1AC5BPAP","6G86L0YR","1CPA9QUC","1IQ1Z9J1","1J7JUGHT","1PRZS9OD","1UB7TOEN","1YHRSDRS","2GKC6IKG","2NEKNNN0","2YZKN7WJ","3H157UGG","3I5QNIPL","3I96HRBH","3L6NSMKN","3QR6WN9O","4FQ7ZJCZ","4JFGKFJE","4M9OGG3W","4ORXG3HX","4Q9EY2N2","4YQOC1L6","4ZABMT0O","05GHT682","5IZRDBLF","5O2L6OBR","5TP9JUKY","6CMZWYVC","6JUUM843","7A6GMG37","7FRKGN6V","7HG7B86U","7JRD1I2O","7MHRSUGD","7RR7RPRB","7VQH31JF","8BSLCDQX","8QFITBH2","8TDH3D1C","8WKBZKAA","8XXR959O","9C5EWCZ8","9NCUTX2R","9PTNRMQS","9XFPHG3K","9ZC655F8","20B4PWW5","25YDTRBH","43EXI7CU","51UXAZ95","54UQEP2B","80GN1X6G","86D85SC0","179FAGS9","745F0PPA","23420RDV","A8JPGZIB","ABBPGBKC","ABC7XMM1","AJ2AEMK5","AO20LGAQ","AQWGJT71","ASJ46884","B5TG7KAD","B7GS3UWW","BAEKB5M0","BV4CJQFO","C3RJU61P","CBA3JSZK","CEHWOOOQ","CKAZYTPD","CSQ15F7I","CXBCTIOL","CZAZ0UIM","D2JOY44B","D08V1E0T","D8ERVVDV","DE4V05DE","DJWZJT0Y","E9677W59","EAQ4116O","EOQH7V9Y","ESKX1DVV","EZ03DH9Z","FJYIHQV7","FK19FYUS","FQ69XXFS","FTL1GJ3U","FXPC2FN3","FY2GBQST","FYNSI215","G3YX3ZVZ","GBDKRM0C","GKHG4IX0","GLYQNYO2","GWAI621H","H3R99VFJ","HDSU9L4I","HJ7HZWDW","HK2J98F5","HKRC8W78","HNNN8CQC","HSXXCD3L","I1G1D5BN","I9NDGJ6S","IIJ7N2SA","IKY82JQA","IPB0AD1W","J2AV1IAR","J2ERK5T2","J33JEU6G","J2288EWM","JCTHLBUZ","JR5DVIR8","K3IG9UD1","K81BUJFF","KFDZ2OYN","KMXDPKQ5","KRUIIQF8","L5KDQ3N9","LBG0KGJP","LBJQMLS3","LET24EB0","LH5W2BF8","LVZU9GVP","LYJ2S3CA","M9XKHME2","MONOOJW7","MS217UXO","N3KJEHZE","N5FJ3Q8N","NIPLCDAO","NNI8AEWN","NXI46IEC","O23S8S14","OGX4EYHR","ORNSFBJG","OYZA4JXX","P0ZOWCN5","P1FT46OM","P2YZRDAR","P8CKAHI6","PAXYMRNP","PBC47CJX","PMS64CBK","PNOITWVH","PNQ1D14D","Q8AUFKTE","QMY2EBLL","QO6RST0J","QQ08O798","QRURCTC1","R7IEWGK4","R106XJ69","RC6I8MB3","RFD9WUGL","RH4HLYYW","RM7YJ796","RS1YZ4QG","RSK0GYCK","6LHEKUYP","1JJJ1RVI","3X2HZKCJ","8A45T2TN","BG8WHHFN","G7VRIT8V","HQ5Y0R85","LXNYQZ01","MKBHPAN1","OEFLYUM9","OP8IG6BG","OTDYPY5G","OUNKO8W2","P8YZ9AW7","PH8LGRMU","PSNU1I5C","PYA9KNSV","Q1FHLPC4","Q4XVL8NI","QAMG8597","QHZHZD5T","QIZ0US0W","QQ2AIY4C","QXVLCVDX","R9P5XFYG","RH5658NE","RNBNQLA9","S5VD7C5Z","S7BK3HQH","SLPF1EOJ","SNIEBUFE","SRC366Q7","SU7W6XK5","UCAO4HF2","UFHK5LHT","UNYNM571","URERJ09Y","UYUU6GNC","V7OJ7YZT","VCD5CQP2","VIYI3AU8","WXR0DTJF","X2UALCEN","XEP72WO9","XUMDGJA3","Y4TVXXEO","YBLF31O5","YO593QAM","YPOWS14G","YQC0VWBX","ZDDGJIK5","09J6UYR9","0IG0PHSG","1X58IJL6","4KR5IW39","4NHL3FTM","4PQM30LM","55L68PF5","6WL6SAG9","7675JYGJ","7JS70LFJ","9QNYAQTT","9W4MUDV5","C6LP7HM2","CSPM5KLQ","DFG7XUE7","DMIQG471","DXHM4W1G","GRFQNFJL","JNO9YT3Z","JRO0P5QZ","K0W0QK3U","K4PAO73E","15NIR75W","2GNRV5GI","5TG40ZZ3","5UFDKBO5","7TEWM8BP","8JIIVB82","8U8813KJ","B2T7PE7I","BM46IVN7","CHBRA106","CPTV3TK6","F3ODAQL5","F94ABV1J","G32QCPNR","K7TWLGR6","KIZOADA1","KY4MM5NE","6UG5F5EE","0552LQJT","L8QEZ9JG","LCYIHKL8","LRAKN2VU","LYMFI2F7","MGW3XR7S","MR0SE0TX","MZKRGINI","N5STB345","NFA99OLB","NICOBJRQ","O52R5I7S"],
      allDesigns:{},
      groupedDesigns: [],
      imageMap: {
        "M2ndkvBJc1fc67Ts7YJv":  require("@/assets/TemplateDesigns/Interface_3.png"),
        "ditK7TpNpjG3sXEwGxBy":  require("@/assets/TemplateDesigns/Interface_2.png"),
        "iLjAw41CX5E9YjPgA0KA":  require("@/assets/TemplateDesigns/Interface_1.png"),
      },
      imagesLoaded: 0,
      totalImages: 0, // Will be set dynamically
    };
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // Set breakpoint for mobile
      if (this.isMobile) {
        this.isPreviewVisible = false; // Hide preview on mobile
        this.isNavbarVisible = false;
        this.$refs.navbar.toggleNavbar(false);


      }
    },
    adjustMainContent(isVisible) {
      this.isNavbarVisible = isVisible; 
    },
    
    
    updateDesignTemplate(){
        //basic template
        // var updateType = "designOption"
        var changeData ="iLjAw41CX5E9YjPgA0KA"
        axios
          .put(this.apiURL + "/updateInfo/", {
            accID: this.currUserId,
            change_type: "designOption",
            designOption: changeData,
            id_token: this.id_token,
          })
          .then((response) => {
            if (response.status == 401) {
              alert("Login Expire! Please Login Again");
              router.push("/");
              return ;
            }
            
            // return "OK"
          })
          .catch(() => {
            // Handle error
            // return "error"
          });
            // return "OK"
            

      },
      updateDesignTemplate2(designID){
        // var updateType = "designOption"
        
        var changeData =designID
        axios
          .put(this.apiURL + "/updateInfo/", {
            accID: this.currUserId,
            change_type: "designOption",
            designOption: changeData,
            id_token: this.id_token,
          })
          .then((response) => {
            if (response.status == 401) {
              alert("Login Expire! Please Login Again");
              router.push("/");
              return ;
            }
            this.response = "success";
            this.designOption = designID
            setTimeout(() => {
              this.response = "";
            }, 3000);
          })
          .catch(() => {
            // Handle error
            // return "error"
          });
            // return "OK"
      },
      async checkAuthState() {
        const auth = getAuth();
        await onAuthStateChanged(auth, (user) => {
          if (user) {
            user.getIdToken().then((idToken) => {
            
              this.id_token = idToken;
            });
          } else {
            router.push("/");
          }
        });
      },
      refreshPreview() {
        // This ensures the Preview component re-renders if needed
        this.$refs.previewComponent?.refresh(); // Ensure your Preview component has a refresh method
      }, 
      groupItems(items, groupSize) {
      const groups = [];
      for (let i = 0; i < items.length; i += groupSize) {
        groups.push(items.slice(i, i + groupSize));
      }
      return groups;
    },
      initializeSwiper() {
      //Swiper
      Swiper.use([Navigation, Pagination, EffectCoverflow]);
      
      // this.$nextTick(() => {
        this.swiper=new Swiper('.swiper-container', {
          
          effect: 'slide',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: "auto",
          initialSlide: 0,
          slideToClickedSlide: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
          
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });
  },
  },
  async mounted() {

    this.accID = this.$store.getters.getUserId;
    await this.checkAuthState();
    this.checkScreenSize(); // Check on page load
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener("touchmove", (event) => {
      if (this.isMobile) {
        event.stopPropagation();
      }
    });
    const docRef = await doc(db, "userProfile", this.accID);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      this.currUserId = this.accID
      await onSnapshot(docRef, (doc) => {
          var userData = doc.data();
          this.docData = userData;
          this.address = userData.address;
          this.contactNumber = userData.contactNumber;
          this.email = userData.email;
          this.fb = userData.fb;
          this.insta = userData.insta;
          this.linkedin = userData.linkedin;
          this.name = userData.name;
          this.profileImg = userData.profileImg;
          this.role = userData.role;
          this.twitter = userData.twitter;
          this.website = userData.website;
          this.companyName = userData.companyName;
          this.officeNumber = userData.officeNumber;
          this.faxNumber = userData.faxNumber;
          this.description = userData.description;
          this.youtube = userData.youtube;
          this.tiktok = userData.tiktok;
          this.whatsapp = userData.whatsapp;
          this.tele = userData.tele;
          this.snapchat = userData.snapchat;
          this.currPDFFile = userData.PdfFile;
          this.pdfName = userData.PdfName;
          if (userData.fbReview!=undefined){
              this.fbReview= userData.fbReview;
          }else{
              this.fbReview= "";
          }
          if (userData.googleReview!=undefined){
              this.googleReview= userData.googleReview;
          }else{
              this.googleReview= "";
          }
          if (userData.additionalInfo!=undefined){
              this.additionalInfo= userData.additionalInfo;
          }else{
              this.additionalInfo= "";
          }
          if (userData.imagePreview!=undefined){
              this.imagePreview = userData.imagePreview
              this.staticImagePreview =ref(JSON.parse(JSON.stringify(userData.imagePreview)));
          }else{
              this.docData.imagePreview = this.staticImagePreview
          }
          this.designOption= userData.designOption
          
          if (userData.designOption==undefined){
              this.updateDesignTemplate()
          } 
        });
    }else{
      const q = query(collection(db, "userProfile"), where("userid", "==", this.accID ));
      await onSnapshot(q, async(doc1) => {
        if (!doc1.empty) {
          this.currUserId = doc1.docs[0].id
          const userData = doc1.docs[0].data();
          this.docData = userData;
          this.address = userData.address;
          this.contactNumber = userData.contactNumber;
          this.email = userData.email;
          this.fb = userData.fb;
          this.insta = userData.insta;
          this.linkedin = userData.linkedin;
          this.name = userData.name;
          this.profileImg = userData.profileImg;
          this.role = userData.role;
          this.twitter = userData.twitter;
          this.website = userData.website;
          this.companyName = userData.companyName;
          this.officeNumber = userData.officeNumber;
          this.faxNumber = userData.faxNumber;
          this.description = userData.description;
          this.youtube = userData.youtube;
          this.tiktok = userData.tiktok;
          this.whatsapp = userData.whatsapp;
          this.tele = userData.tele;
          this.snapchat = userData.snapchat;
          this.currPDFFile = userData.PdfFile;
          this.pdfName = userData.PdfName;

           if (userData.fbReview!=undefined){
              this.fbReview= userData.fbReview;
          }else{
              this.fbReview= "";
          }
          if (userData.googleReview!=undefined){
              this.googleReview= userData.googleReview;
          }else{
              this.googleReview= "";
          }
          if (userData.additionalInfo!=undefined){
              this.additionalInfo= userData.additionalInfo;
          }else{
              this.additionalInfo= "";
          }
          if (userData.imagePreview!=undefined){
            this.imagePreview = userData.imagePreview
            this.staticImagePreview =ref(JSON.parse(JSON.stringify(userData.imagePreview)));
          }else{
              this.docData.imagePreview = this.staticImagePreview
          }
          this.designOption= userData.designOption
          
          if (userData.designOption==undefined){
              this.updateDesignTemplate()
          } 
          }else{
            router.push("/NotFound");
          }
        })
    }
    const colRef  = collection(db, "designTemplates");
  
    const deisgnQuery = query(colRef, orderBy("createdTime"));
    const designSnap = await getDocs(deisgnQuery)
    const designTemplateDic = {};
    const designExclusiveDic = {};
    designSnap.forEach(doc => { 
       if (doc.data().exclusive && doc.data().exclusiveList.includes(this.$store.getters.getUserId)) {
          designExclusiveDic[doc.id] = doc.data();
        } else if (!doc.data().exclusive) {
          designTemplateDic[doc.id] = doc.data();
        }
    });
    this.designTemplateDic = designTemplateDic;
    this.designExclusiveDic = designExclusiveDic;
    designSnap.forEach(doc => { 
       if (doc.data().exclusive && (doc.data().exclusiveList.includes(this.$store.getters.getUserId)||doc.data().exclusiveList.includes(this.currUserId))) {
          designExclusiveDic[doc.id] = doc.data();
        } else if (!doc.data().exclusive) {
          designTemplateDic[doc.id] = doc.data();
        }
    });
    if(this.excludeList.includes(this.$store.getters.getUserId)||this.excludeList.includes(this.currUserId)){
      this.designTemplateDic ={};
    }else{
      this.designTemplateDic = designTemplateDic;
    }
    for (let key in this.designExclusiveDic) {
        this.designExclusiveDic[key]["video"] = this.imageMap[key]
    }
    for (let key in this.designTemplateDic) {
        this.designTemplateDic[key]["video"] = this.imageMap[key]
    }
    this.designExclusiveDic = designExclusiveDic;
  //   this.allDesigns = Object.entries({
  //     ...this.designTemplateDic,
  //     ...this.designExclusiveDic,
  //   });
  //  this.allDesigns = this.allDesigns.map(([key, value]) => ({
  //     key,
  //     video: value.video,
  //   }));
  //  console.log(this.allDesigns)

  //   // Group items into slides (3 items per slide)
  //   this.groupedDesigns = this.groupItems(this.allDesigns, 3);
  // },
  this.totalImages = Object.keys(this.designTemplateDic).length + Object.keys(this.designExclusiveDic).length;
    this.$nextTick(() => {
          this.initializeSwiper();
        });
        }
  
};
</script>
<style scoped>
.main-screen {
  display: flex;
  /* height: 100vh; */
  gap: 20px;
}

.navbar-section {
  width: 250px;
  text-align: left;
}

.main-content {
  height: 100vh;
  flex: 2;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  overflow-y: auto;
  text-align: left !important; /* Override Bootstrap */
  justify-content: flex-start !important; /* Ensure left alignment */
  align-items: flex-start !important; /* For flex containers */
}

.profile-picture img {
  max-width: 100px;
  border-radius: 50%;
  /* display: block; */
  /* margin: 0 auto 10px; */
}

/* .profile-picture input {
  display: block;
  margin: 10px auto;
} */

.sections .section {
  margin-bottom: 20px;
}

.preview-section {
  width: 350px; /* Matches the card width */
  height: auto; /* Adjusts to the content height */
  z-index: 1000; /* Ensures it stays above other elements */
  background-color: transparent; /* Transparent background to blend with the page */
}
.navbar-section {
  transition: width 0.3s ease;
  overflow: hidden; /* Prevent content overflow when hidden */
}

.navbar-section.hidden {
  width: 0; /* Collapse navbar */
}
.main-content {
  flex: 2;
  transition: flex 0.3s ease; /* Smooth adjustment */
}

.main-content.full-width {
  flex: 1; /* Take over the space */
}
.main-screen{
  background-color: #f9f9f9;
  text-align: left !important; /* Override Bootstrap */
  justify-content: flex-start !important; /* Ensure left alignment */
  align-items: flex-start !important; /* For flex containers */
}

.profile-picture {
  text-align: center;
}

.image-container {
  display: flex;
  align-items: left;
  gap: 20px; /* Space between image and the upload actions */
  margin-bottom: 10px;
}

.image-container img {
  width: 100px;
  height: 100px;
  border-radius: 50%; /* Circular image */
  object-fit: cover;
  background-color: #e0e0e0; /* Fallback background */
}

.upload-actions {
  display: flex;
  flex-direction: column; /* Stack button and text vertically */
  align-items: flex-start; /* Align text and button to the left */
  padding-top:20px;
}

.upload-button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 10px; /* Space between button and text */
}

.upload-button:hover {
  background-color: #f7f7f7;
  border-color: #aaa;
}

.file-input {
  display: none; /* Hidden input */
}

.upload-info {
  font-size: 12px;
  color: #666;
  margin-left: -12px;  
}

/* custom-custom-modal Styles */
.custom-custom-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background: white;
  border-radius: 10px;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  text-align: center;
}

.custom-custom-modal img.crop-img {
  max-width: 100%;
  max-height: 300px;
}

.custom-custom-modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.cropper-container .cropper-face {
  border-radius: 50% !important; /* Makes the crop box circular */
}

.crop-button {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.crop-button:hover {
  background-color: #45a049;
}

.cancel-button {
  padding: 10px 20px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #d32f2f;
}

.custom-custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
/*info*/
/* Personal Info Card */
.personal-info-card {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

/* Card Header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: transparent !important;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
}

.save-button {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-size: 0.9rem;
  border: 1px solid #757575;
  background-color: #fff;
  color: #333;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 10px;
}

.save-button:hover {
  background-color: #f5f5f5;
}

.save-button i {
  margin-right: 5px;
}

/* Card Content */
.info-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: .5rem 1rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.info-column {
  /* display: flex;
  flex-direction: column;
  flex: 1; */
  position: relative;
    overflow: hidden;
    max-width: 100%;
    padding: 0;
    box-sizing: border-box;
}

.info-label {
  font-size: 0.85rem;
  color: #aaa;
  margin-bottom: 5px;
}

.info-value {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.info-input {
  font-size: 1rem;
  color: #333;
  border: none;
  border-bottom: 1px solid #ccc; /* Solid underline */
  outline: none;
  background: transparent;
  width: 100%;
}

.info-input:focus {
  border-bottom: 1px solid #000;  /* Highlight border on focus */
}


.save-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 0.9rem;
  padding: 8px 12px;
  /* border: none; */
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Spinner Style */
.spinner {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #000;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
  }
.image-preview-container {
  position: relative;
  width: 100px; /* Fixed width, adjust as needed */
  /* height: 100px; Fixed height, adjust as needed */
  padding: 0;
  margin: 0; 
}

.image-upload-box {
  border: 2px dashed #ccc;
  width: 100px; 
  height: 100px; 
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 100%; 
  height: auto; 
  padding: 10px;  */
}
/* Preview Section */
.preview-card {
  position: fixed; /* Keeps the card fixed on the right */
  top: 20px; /* Adds spacing from the top */
  right: 20px; /* Aligns it to the right */
  width: 350px; /* Fixed width for the card */
  background-color: #fff; /* White background for better visibility */
  border-radius: 12px; /* Rounded corners */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for the card */
  padding: 20px; /* Padding inside the card */
  z-index: 1000; /* Ensures it stays above other elements */
}

.preview-title {
  font-size: 1.2rem; /* Title font size */
  font-weight: bold; /* Bold text */
  margin-bottom: 10px; /* Spacing below the title */
}

.preview-content {
  height: 500px; /* Fixed height for the card */
  display: flex;
  justify-content: center; /* Center content horizontally */
  align-items: center; /* Center content vertically */
  overflow: hidden; /* Hides overflow content */
  background-color: #f9f9f9; /* Optional background */
}

.preview-content img {
  max-width: 100%; /* Ensures the image doesn't exceed the container's width */
  max-height: 100%; /* Ensures the image doesn't exceed the container's height */
  object-fit: contain; /* Maintain aspect ratio and fit the container */
}
@media (max-width: 768px) {
  .personal-info-card {
    font-size: 14px; /* Reduce font size for better fit */
  }

  .info-row {
    flex-direction: column; /* Stack items vertically */
  }

  .info-value {
    font-size: 12px; /* Smaller font for better alignment */
    overflow: hidden; /* Prevent overflow */
    text-overflow: ellipsis; /* Show "..." if text is too long */
  }
}
.swiper-container {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    text-align: center;
}

.btn-select {
    margin-top: 10px; /* Adds space between the image and the button */
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
}
.swiper-slide{
    display: flex;
    flex-direction: column;
    align-items: center; /* Center aligns the button with the image */
    text-align: center;
}
 
 .card {
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-img-top {
  max-height: 200px;
  object-fit: cover;
}

.carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-select {
  margin-top: 10px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: black; /* Optional: Change arrow colors */
}



</style>